import React, { useEffect } from "react";
import { useSnackbar } from "notistack";

const AlertMsg = ({
  successSnackbarMessage,
  successSnackbarOpen,
  successSnackbarInfo,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (successSnackbarOpen) {
      enqueueSnackbar(successSnackbarMessage, {
        variant: successSnackbarInfo,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    }
  });

  return null;
};

export default AlertMsg;
